import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArkchatLogoCard from "../common/ArkchatLogoCard";
import playStore_icon from "../assets/images/playStore_icon.svg";
import appleAppstore_icon from "../assets/images/appleAppstore_icon.svg";

const MobileView = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });

  return (
    <>
      <Box width={"90%"} margin={"auto"}>
        <Grid container direction="column" spacing={2}>
          <Grid item xs={12}>
            <ArkchatLogoCard height="28rem" />
          </Grid>
          <Grid item xs={12}>
            <Box mb={"0.8rem"}>
              {/* Additional content can be placed here */}
              <Typography mb={"0.8rem"} variant="h5">
                {appContent?.KEY132}
              </Typography>
              <Typography variant="body1">
                {appContent?.KEY266}
              </Typography>
              <Box mt={"1rem"} mb={"1rem"}>
                <Box textAlign={"center"} mb={"0.5rem"}>
                  <a href="https://apps.apple.com/in/app/arkchat/id1618932796">
                    <img
                      style={{ cursor: "pointer" }}
                      src={appleAppstore_icon}
                      alt=""
                    />
                  </a>
                </Box>
                <Box textAlign={"center"}>
                  <a href="https://play.google.com/store/apps/details?id=com.arkchat">
                  <img
                    style={{ cursor: "pointer" }}
                    src={playStore_icon}
                    alt=""
                  />
                  </a>
                </Box>
              </Box>
              <Typography variant="body1">
                {appContent?.KEY267}{" "}
                <a href="https://platform.arkchat.com/">
                  https://platform.arkchat.com/
                </a>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MobileView;
